module.exports = __webpack_public_path__ + "img/svg/paperclip.a1b9a0287b2c3ef80828a290c09df16b.svg";